module.exports = __webpack_public_path__ + "img/hr-constant-combinator-shadow.1f020524.png";